(ns app.front.view.group.admin.conditions.subs
  (:require [app.front.view.group.admin.core :as acore]
            [re-frame.core-instrumented :as rf]))

(def fetch-cmd :group/condition-templates)

(rf/reg-event-fx ::fetch-templates
  (fn [_ [_ group-id]]
    {:fx [[:dispatch [::acore/set-fetching-config group-id fetch-cmd]]
          [:comm/command {:command    fetch-cmd
                          :method     :get
                          :data       {:authority-group-id group-id}
                          :on-success [::fetch-templates.success group-id]}]]}))

(rf/reg-event-fx ::fetch-templates.success
  (fn [{:keys [db]} [_ group-id status {:keys [entities templates-in-use]}]]
    {:db (assoc-in db [::data group-id :templates-in-use] templates-in-use)
     :fx [[:dispatch [::acore/config-fetched group-id fetch-cmd status entities]]]}))

(rf/reg-sub ::fetching-templates-for-group?
  (fn [[_ group-id]]
    (rf/subscribe [::acore/fetching-config? group-id fetch-cmd]))
  :-> boolean)

(rf/reg-sub ::data
  :-> ::data)

(rf/reg-sub ::templates-in-use-for-group
  :<- [::data]
  (fn [data [_ group-id]]
    (get-in data [group-id :templates-in-use] #{})))
